export default __webpack_public_path__ + "static/media/skirmishers_mark_of_abhorrence.85ed91de.jpg";